import { Link } from "react-router-dom";
import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { RevealLines, Tilt, EASE } from "../components/site/motion";
import { FeatureCards, Journey, Vision } from "../components/sections/Overview";
import { Marquee } from "../components/site/Marquee";
import { M } from "../data/site";
import { DemoVideoModal } from "../components/site/DemoVideoModal";

export default function Features() {
  const [demoOpen, setDemoOpen] = useState(false);
  return (
    <div data-testid="features-page">
      <section className="relative mx-auto grid max-w-[1440px] items-center gap-12 px-5 pb-16 pt-32 lg:grid-cols-12 lg:px-12 lg:pt-40">
        <div className="pointer-events-none absolute right-0 top-20 h-[520px] w-[520px] rounded-full bg-cyan-500/15 blur-[150px]" />
        <div className="relative lg:col-span-5">
          <p className="eyebrow mb-6">Features</p>
          <RevealLines testId="features-headline" className="font-display text-5xl font-bold leading-[0.98] tracking-tight text-white sm:text-6xl xl:text-7xl"
            lines={[{ text: "Meet the" }, { text: "intelligence" }, { text: "behind the", className: "text-grad" }, { text: "moments.", className: "text-grad" }]} />
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: EASE, delay: 0.5 }} className="mt-7 max-w-md text-base text-slate-200 md:text-lg">
            Thoughtful guidance for everyday life, beginning in the kitchen.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: EASE, delay: 0.65 }} className="mt-9 flex flex-wrap gap-4">
            <button onClick={() => setDemoOpen(true)} data-testid="features-watch-demo-btn" className="btn-primary"><Play className="h-4 w-4 fill-white" /> Watch the Demo</button>
            <Link to="/waitlist" data-testid="features-join-waitlist-btn" className="btn-ghost">Join Waitlist <ArrowRight className="h-4 w-4" /></Link>
          </motion.div>
        </div>
        <motion.div initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.4, ease: EASE, delay: 0.2 }} className="relative lg:col-span-7">
          <Tilt max={5}>
            <div className="relative aspect-[16/12] overflow-hidden rounded-[2rem] glow-edge">
              <img src={M("c_features_hero.jpg")} alt="Honesti guiding a young girl as she cooks" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
            </div>
          </Tilt>
        </motion.div>
      </section>
      <FeatureCards />
      <Marquee />
      <Journey />
      <Vision />
      <DemoVideoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
